<ng-template [ngTemplateOutlet]="rootTemplate"></ng-template>

<ng-template #rootTemplate>
	@if (initialAppVersionState(); as appVersionResult) { @if (appVersionResult.isOutdated) {

	<div class="w-root-container">
		<div class="centered">
			<h1>New version available</h1>
			<div class="version-identifier">{{ appVersionResult.newVersion }}</div>
			<div class="text">To continue using the app, please update it by clicking on the button below.</div>
			<div class="text-2">
				If that does not help, please try clearing your browser cache. Using <strong>CTRL + F5</strong> shortcut
				usually forces your browser to reload latest resources. Your version is
				{{ appVersionResult.currentVersion }}
			</div>
			<div class="refresh-button-wrapper">
				<button class="refresh-button" (click)="handleUpdateApp()">Update app</button>
			</div>
		</div>
	</div>

	} } @if (!initialAppVersionState() || !initialAppVersionState()?.isOutdated) {
	<div role="main">
		<router-outlet></router-outlet>
	</div>

	@for (dialogType of dialogTypes; track dialogType ) {
	<lib-dialog [dialogType]="dialogType"></lib-dialog>
	} @if (showAppVersionLoadingError()) {
	<div class="w-root-container">
		<div class="centered">
			<h1>Offline</h1>
			<div class="text">It appears you lost network connection.</div>
			<div class="refresh-button-wrapper">
				<button class="refresh-button" (click)="handleUpdateApp()">Refresh</button>
			</div>
		</div>
	</div>
	} }
</ng-template>
